// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__ahSGg","active":"Uploader_active__nVrp-"};